export function getClientIdFromReturnUrl(returnUrl?: string): string | null {
  if (!returnUrl) return null;
  try {
    const u = new URL(returnUrl, window.location.origin);
    return u.searchParams.get('client_id') || u.searchParams.get('clientId');
  } catch {
    return null;
  }
}

export function shouldHideLinks(opts: {
  signedOut?: boolean;
  clientId?: string;
  returnUrl?: string;
}) {
  const isBmStudio = opts.clientId === 'bmstudio';
  return Boolean(opts.signedOut) || isBmStudio;
}
